import { Alert, Autocomplete, Avatar, Chip, Divider, Grid, IconButton, Modal, Tab, Table, TableBody, TableCell, TableHead, TableRow, Tabs, TextField, tableCellClasses } from '@mui/material';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import Box from '@mui/material/Box';
import { GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { PermissionsEnum } from "../../utils/auth.types";

import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import { fetchInventories } from '../../store/inventoryStore/inventoryThunk';
import { Inventory } from '../../utils/inventory.types';

import styled_ from "@emotion/styled";
import { makeStyles } from '@material-ui/core';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import { useNavigate, useParams } from "react-router-dom";
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { TabPanel } from '../Dialog/TabPanel';
import DefaultClientImg from './client.png';
import DefaultImg1 from './defaultImg.png';
import DefaultEmpImg from './product.png';
// import AdjustStock from './AdjustStock';
// import PartyPrice from './PartyPrice';
import CloseIcon from '@mui/icons-material/Close';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import PreviewIcon from '@mui/icons-material/Preview';
import { deleteEmpAttachment, fetchEmployeeById } from '../../store/employeeStore/employeeThunk';

import DocAttachInfo from '../DocumentAttachment/DocAttachInfo';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export const StyledBoxLoader = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fffffff2;
  z-index: 9999999;

  .MuiCircularProgress-root {
    left: 50%;
    top: 10%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: relative;
  }
`;

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  width: 425,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
};

const images = [
  {
    label: 'San Francisco – Oakland Bay Bridge, United States',
    imgPath:
      'https://images.unsplash.com/photo-1537944434965-cf4679d1a598?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bird',
    imgPath:
      'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
  },
  {
    label: 'Bali, Indonesia',
    imgPath:
      'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
  },
  {
    label: 'Goč, Serbia',
    imgPath:
      'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
  },
];

const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: 3,
  width: 15,
  height: 15,
  boxShadow:
    //   theme.palette.mode === 'dark'
    // ? '0 0 0 1px rgb(16 22 26 / 40%) ' :
    'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor:
    // theme.palette.mode === 'dark' ? '#394b59' : 
    '#f5f8fa',
  backgroundImage:
    //   theme.palette.mode === 'dark'
    // ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))' :
    'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor:
      //   theme.palette.mode === 'dark' ? '#30404d' : 
      '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      // theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 
      'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
    display: 'block',
    width: 15,
    height: 15,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#106ba3',
  },
});

const StyledTableCell = styled_(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#fff',
    color: '#9da7b7',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    margin: 0,
    padding: 5,
    fontSize: 13,
    paddingLeft: '15px !important',
  },
  [`&.${tableCellClasses.footer}`]: {
    backgroundColor: '#f5f5f5',
    color: 'black',
    borderTop: '0.25px solid #d9d4d4',
    borderBottom: '0.25px solid #d9d4d4',
    left: 0,
    bottom: 0, // <-- KEY
    zIndex: 2,
    position: 'sticky'
  },
  [`&.${tableCellClasses.body}`]: {
    verticalAlign: 'super',
    fontSize: 14,
    fontWeight: 'normal',
    color: '#292d35',
    padding: 5,
    border: 'none',
    paddingLeft: '15px !important',
    margin: 0
  },
}));

const StyledTableRow = styled_(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: '#fbfbfb',
    // border: '0.5px dashed #9da7b7',
  },
  '&:nth-of-type(odd)': {
    backgroundColor: '#e9ecf1',
    // border: '0.5px dashed #9da7b7',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
  },
}));


interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#635ee7',
  },
});

interface TabPanelProps {
  index: number;
  value: number;
}

const StyledTabPanel = styled((props: TabPanelProps) => (
  <TabPanel
    {...props}
  />
))({
  '& .MuiBox-root': {
    backgroundColor: 'transparent !important',
    padding: '0px !important'
  }
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: '#545454',
  '&.Mui-selected': {
    color: '#1890ff',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'rgba(100, 95, 228, 0.32)',
  },
}));


interface EmployeeViewProps {
  type?: string;
}

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    boxShadow: 'none',
    borderRadius: 7
  },
  toggleButtonGroup: {
    width: '100%',
  },
  toggleButton: {
    width: 15,
    height: 15,
    marginBottom: 2
  },

});

interface DoucumentProps {
  name: string;
  document: any;
  mimetype?: any;
}

const EmployeeViewPage: FC<EmployeeViewProps> = (type) => {
  const { employeeId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const classes = useStyles();
  const { employees, status } = useAppSelector(state => state.employees);
  const employeeDetails = useAppSelector(state => state.employees.employeeDetails);
  const { permissions, selectedAccount } = useAppSelector(state => state.auth);

  const [isLoading, setIsLoading] = useState(false);

  const [document, setDocument] = useState<DoucumentProps>();
  const [documentModel, setDocumentModel] = useState(false);
  const [fetchData, setFetchData] = useState('');
  const canUpdateAccount = permissions?.includes(PermissionsEnum.Account_Update);

  const [docData, setDocData] = useState<any[]>([]);
  const [fetchDocs, setFetchDocs] = useState('');
  const [refreshDocs, setRefreshDocs] = useState(false);
  const [docDeleteId, setDocDeleteId] = useState("");

  const [value, setValue] = useState(0);
  const [presentAddress, setPresentAddress] = useState("");
  const [permanentAddress, setPermanentAddress] = useState("");
  const [baseLocationAddress, setBaseLocationAddress] = useState("");

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  // fetch current inventory details on edit
  useEffect(() => {
    if (employeeId) {
      dispatch(fetchEmployeeById(employeeId));
    }
  }, [employeeId, dispatch]);

  useEffect(() => {
    if (employeeDetails) {
      if (employeeDetails.attachments && employeeDetails.attachments.length > 0) {
        let docs = employeeDetails.attachments
        let len = docs.length;
        setDocData(docs);
      }
      setAddresses(employeeDetails);
    }
  }, [employeeDetails]);

  const closeDocAttach = (isSaved: boolean) => {
    console.log("closeDocAttach Called ---")
    if (isSaved) {
      setRefreshDocs(true);
      setFetchDocs(Math.random().toString());
      setFetchData(Math.random().toString());
    }
  }
  const docDelete = (id: any) => {
    setDocDeleteId(id);
  }

  useEffect(() => {
    if (docDeleteId) {
      let docs = docData.filter(doc => doc._id !== docDeleteId);
      setDocData([...docs]);
      setDocDeleteId('');
    }
  }, [docDeleteId])

  useEffect(() => {
    if ((employeeDetails.attachments) && fetchDocs && refreshDocs) {
      let docs = employeeDetails.attachments
      let len = docs.length;
      setDocData(d => [...d, docs[len - 1]]);
    }
  }, [employeeDetails.attachments, fetchDocs, refreshDocs])

  const handleEditInventoryClick = useCallback(({ _id }: Inventory) => {
    //Call edit function
    let navLink = `/inventory/edit/${_id}`;
    navigate(navLink);

  }, []);


  const handleAddInventory = () => {
    const navLink = `/inventory/create`;
    navigate(navLink);
  };

  /**
    * Fetch all the accounts on Accounts page load.
    */
  useEffect(() => {
    const { _id: id } = selectedAccount;
    setIsLoading(true);
    dispatch(fetchInventories({ accountId: id, type: '', params: '' }));
    setIsLoading(false);
  }, [dispatch, selectedAccount]);

  /** 
    * Column defs for Employee Education list data grid.
  */
  const columns: GridColDef[] = useMemo(() => [

    {
      field: "CourseName",
      headerName: 'Course Name/Type',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.educationEstablishment} <br /> {row.courseDescription} </p>
        )
      }
    },
    {
      field: "university",
      headerName: 'University & School/College',
      type: "string",
      width: 300,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.university} <br /> {row.schoolCollegeName}</p>
        )
      }
    },
    {
      field: "yearOfPassing",
      headerName: 'YOP',
      type: "string",
      width: 90,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.yearOfPassing}</p>
        )
      }
    },
    {
      field: "percentage",
      headerName: '%',
      type: "string",
      width: 70,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.percentage}</p>
        )
      }
    },
    {
      field: "startDate",
      headerName: 'Start Date',
      type: "string",
      width: 100,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.startDate}</p>
        )
      }
    },
    {
      field: "endDate",
      headerName: 'End Date',
      type: "string",
      width: 100,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.endDate}</p>
        )
      }
    },
  ], []);

  /** 
    * Column defs for Employee Prev Employer list data grid.
  */
  const columnsPrevEmployer: GridColDef[] = useMemo(() => [

    {
      field: "employerName",
      headerName: 'Employer Name',
      type: "string",
      width: 300,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.name} <br />
            <span style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>
              {moment(row.start_date).format("DD MMM YYYY")} -- {moment(row.end_date).format("DD MMM YYYY")} </span>
          </p>
        )
      }
    },
    {
      field: "title",
      headerName: 'Title',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.title}</p>
        )
      }
    },
    {
      field: "grossSalary",
      headerName: 'Gross Salary',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.gross_salary}</p>
        )
      }
    },
    {
      field: "ctc",
      headerName: 'CTC',
      type: "string",
      width: 150,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.ctc}</p>
        )
      }
    },
    {
      field: "isCurrentEmployer",
      headerName: 'Current Employer',
      type: "string",
      width: 100,
      renderCell: ({ row, value }: GridValueGetterParams) => {

        return (
          <p>{row.isCurrentEmployer ? 'Yes' : 'No'}</p>
        )
      }
    },
  ], []);

  const handleEditEmployeeClick = useCallback((_id: any) => {
    //Call edit function
    let navLink = `/employee/edit/${_id}`;
    navigate(navLink);

  }, []);

  const handleAddEmployee = () => {
    const navLink = `/employee/create`;
    navigate(navLink);
  };

  const handleBackButtonClick = useCallback(() => {
    //Call edit function
    let navLink = `/employee`;
    navigate(navLink);

  }, []);

  const handleEmpDeleteAttachment = async (attachmentName: any, attachmentId: any = '') => {
    let data: any = {};
    if (attachmentId) {
      data.attachmentId = attachmentId;
    } else {
      if (attachmentName == 'photo') {
        data.photo = true;
      }
      if (attachmentName == 'signature') {
        data.signature = true;
      }
    }


    console.log("handleEmpDeleteAttachment === ", data);

    if (Object.entries(data).length > 0) {
      try {
        await dispatch(deleteEmpAttachment({ id: employeeDetails._id, employeePayload: data, })).then((data) => {
          if (data) {
            dispatch(fetchEmployeeById(employeeDetails._id));
          }
        }).catch(e => {
          console.log(e);
        });;
      } catch (error: any) {
        console.log(error);
      }
    }
  }

  const setAddresses = (object: any) => {
    let address = object.addresses;
    if(address) {
      let currentAdd = address.find((item: any) => item.type === 'Present Address') || [];
      let permanentAdd = address.find((item: any) => item.type === 'Permanent Address') || [];
      if (currentAdd) {
        let _presentdddress = [currentAdd.line1, currentAdd.line2, currentAdd.city, currentAdd.state.name, currentAdd.country.name, currentAdd.code];
        setPresentAddress(_presentdddress.filter(n => n).join(", "));
      }
      if (permanentAdd) {
        let _permanentAddress = [permanentAdd.line1, permanentAdd.line2, permanentAdd.city, permanentAdd.state.name, permanentAdd.country.name, permanentAdd.code];
        setPermanentAddress(_permanentAddress.filter(n => n).join(", "));
      }
      if (object.baseLocation) {
        const _b = object.baseLocation;
        let _baseLocation = [_b.line1, _b.line2, _b.city, _b.state.name, _b.country.name, _b.code];
        setBaseLocationAddress(_baseLocation.filter(n => n).join(", "));
      }
    }
  };

  return (
    <>
      <Grid container p={0} spacing={2} position={'fixed'} mt={-2} zIndex={0}>

        <Grid item xs={8} >
          {employeeDetails && <>
            {/* <StyledBoxLoader sx={{ mt: 1 }}><CircularProgress color="inherit" /></StyledBoxLoader> */}
            <Box component="form" noValidate sx={{ borderRadius: '12px', border: '3px solid #e9ecf1', backgroundColor: '#fff' }}>
              <Grid container>
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, pt: 1.5, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
                  <div style={{ float: 'right', marginTop: -5, marginRight: -5 }}>
                    <IconButton
                      style={{ color: '#488dff', backgroundColor: '#fff', border: '0.1px solid #488dff', height: 35, width: 35, marginRight: 10 }}
                      size='small' onClick={() => handleAddEmployee()}><AddIcon style={{ fontSize: 16 }} />
                    </IconButton>
                    <IconButton
                      style={{ color: '#488dff', backgroundColor: '#fff', border: '0.1px solid #488dff', height: 35, width: 35, marginRight: 10 }}
                      size='small' onClick={() => handleEditEmployeeClick(employeeId)}><EditIcon style={{ fontSize: 16 }} />

                    </IconButton>
                    {/* <IconButton disabled
                  style={{color:'#c33b3b',backgroundColor:'#fff',border:'0.1px solid #c33b3b',height:35,width:35 }}
                  size='small' ><DeleteIcon style={{fontSize:16}}/>
              </IconButton> */}
                  </div>
                  <IconButton onClick={() => handleBackButtonClick()} style={{ float: 'left', color: '#545454', backgroundColor: '#f5f5f5', border: 'none', height: 35, width: 35, marginTop: -5, marginRight: 10, marginLeft: -5 }} size='small' >
                    <NavigateBeforeOutlinedIcon style={{ fontSize: 20 }} />
                  </IconButton>
                  <h3 style={{ marginTop: -1, fontWeight: 600 }}>Employee : {employeeDetails.name} ({employeeDetails.empId})</h3>
                </Grid>
              </Grid>

            </Box>
          </>}
        </Grid>
      </Grid>

      <Grid container p={0} spacing={2} pt={8} >
        <Grid item xs={9}>

          <Box sx={{ bgcolor: '' }}>
            <StyledTabs value={value} onChange={handleChange} aria-label="styled tabs example">
              <StyledTab label="General" />
              <StyledTab label="Family" />
              <StyledTab label="Education" />
              <StyledTab label="Compliance" />
              <StyledTab label="Previous Employment" />
              <StyledTab label="Documents" />
            </StyledTabs>
            <StyledTabPanel value={value} index={0} >
              <Grid container spacing={2} >
                {employeeDetails && <>
                  <Grid item xs={3.5}>
                    <div className={'c-card2'} style={{ padding: 12, paddingTop: 12, textAlign: 'center' }}>
                      <img src={(employeeDetails && employeeDetails.photo) ? employeeDetails.photo : DefaultImg1} style={{ width: '100%', height: 'auto', borderRadius: 15, border: '.5px solid #e9ecf1', objectFit: 'cover' }} />
                      <p style={{ fontWeight: 'normal', color: '#000', fontSize: 15, marginTop: 10 }}>

                        {(employeeDetails && employeeDetails.photo) &&
                          <Chip onClick={() => {
                            handleEmpDeleteAttachment('photo');
                          }}
                            size='small'
                            style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12 }}
                            label={<>Remove Profile<DeleteIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>}
                          />
                        }
                      </p>
                      <br />
                      <p style={{ fontWeight: 'normal', color: '#000', fontSize: 15, marginTop: 10 }}>{employeeDetails.name} </p>
                      <p>Employee Id : {employeeDetails.empId}</p>
                      <Divider sx={{ mt: 2, mb: 2 }} />
                      <p  >28 yrs | Unmarried</p>
                      <p style={{ marginTop: 10 }}>{(employeeDetails && employeeDetails.languages) ? employeeDetails.languages.join(', ') : 'No Langauges Selected'}</p>
                      <p style={{ marginTop: 10 }}>{String(`${employeeDetails.personalEmail}`).length > 30 ? String(`${employeeDetails.personalEmail}`).substring(0, 28) + '...' : String(`${employeeDetails.personalEmail}`)}</p>
                      <p style={{ marginTop: 10 }}>+91 {employeeDetails.primaryPhone}</p>
                      <p style={{ marginTop: 10, marginBottom: 10 }}>{employeeDetails.presentAddress}</p>
                    </div>
                  </Grid>
                </>}
                <Grid item xs={8.5}>
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Business Unit</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    {employeeDetails.client && <>
                      <Grid container spacing={2}>
                        <Grid item xs={2}>
                          <img src={(employeeDetails.client && employeeDetails.client.logo) ? employeeDetails.client.logo : DefaultClientImg} style={{ marginTop: 5, width: '100%', height: 'auto', padding: 5, borderRadius: 15, border: '.5px solid #e9ecf1', objectFit: 'cover' }} />
                        </Grid>
                        <Grid item xs={10}>
                          <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Business Unit Name</h5>
                          <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 10 }}>{String(`${employeeDetails.client.name}`).length > 70 ? String(`${employeeDetails.client.name}`).substring(0, 68) + '...' : String(`${employeeDetails.client.name}`)}</h5>
                          <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Base Location</h5>
                          <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>{baseLocationAddress}</h5>
                        </Grid>
                      </Grid>
                    </>}
                  </div>
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10, marginTop: 15 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Contact & Address Details</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Personal Email</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.personalEmail) ? employeeDetails.personalEmail : '-'}</h5>
                      </Grid>
                      <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Personal Phone</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.primaryPhone) ? employeeDetails.primaryPhone : '-'}</h5>
                      </Grid>
                      <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Alternate Phone</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>+91 {(employeeDetails && employeeDetails.alternatePhone) ? employeeDetails.alternatePhone : '-'}</h5>
                      </Grid>

                      <Grid item xs={12}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Current Address</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(presentAddress && presentAddress != "") ? presentAddress : '-'}</h5>
                      </Grid>
                      <Grid item xs={12}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Permanent Address</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(permanentAddress && permanentAddress != "") ? permanentAddress : '-'}</h5>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={1} >
              <Grid container spacing={2} >
                <Grid item xs={6}>
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Family Details</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Father Name</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.fatherName) ? employeeDetails.fatherName : '-'}</h5>
                      </Grid>
                      <Grid item xs={6}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Mother Name</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.motherName) ? employeeDetails.motherName : '-'}</h5>
                      </Grid>
                      {/* <Grid item xs={12}>
                    <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:13}}>Marital Status</h5>
                    <h5 style={{fontWeight:'normal',color:'#000',fontSize:14,marginBottom:3}}>Married</h5>
                  </Grid> */}
                      <Grid item xs={6}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Spouse Name</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.spouseName) ? employeeDetails.spouseName : '-'}</h5>
                      </Grid>
                      <Grid item xs={6}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Spouse Phone</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>+91 {(employeeDetails && employeeDetails.spousePhone) ? employeeDetails.spousePhone : '-'}</h5>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={'c-card2'} style={{ padding: 0, marginTop: 15 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 7 }}>Dependents</h5>

                    {(employeeDetails.dependents && employeeDetails.dependents.length > 0) ?
                      <div style={{ marginBottom: 12, marginTop: 5 }}>
                        <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell width={235}>Name</StyledTableCell>
                              <StyledTableCell width={230}>Relation</StyledTableCell>
                              <StyledTableCell width={225}>Date Of Birth</StyledTableCell>
                              <StyledTableCell width={165}>Phone No.</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {employeeDetails.dependents.map((e: any) =>
                              <StyledTableRow key={e.id}>
                                <StyledTableCell>{e.full_name}</StyledTableCell>
                                <StyledTableCell>{e.relation}</StyledTableCell>
                                <StyledTableCell>{moment(e.dob).format("DD MMM YYYY")}</StyledTableCell>
                                <StyledTableCell>{e.phone}</StyledTableCell>
                              </StyledTableRow>
                            )}
                          </TableBody>
                        </Table>
                      </div> :
                      <div style={{ height: 200 }}>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <span style={{ marginLeft: 15 }}>No Data</span> </div>
                    }
                  </div>
                </Grid>
                <Grid item xs={6}>
                  <div className={'c-card2'} style={{ padding: 0 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 7 }}>Emergency Contacts</h5>

                    {employeeDetails.emergencyPhones && employeeDetails.emergencyPhones.length > 0 ?
                      <div style={{ marginBottom: 12, marginTop: 5 }}>
                        <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell width={220}>Contact Name</StyledTableCell>
                              <StyledTableCell width={210}>Phone No.</StyledTableCell>
                              <StyledTableCell width={155}>Relation</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {employeeDetails.emergencyPhones.map((e: any) =>
                              <StyledTableRow key={e.id}>
                                <StyledTableCell>{e.name}</StyledTableCell>
                                <StyledTableCell>{e.phone}</StyledTableCell>
                                <StyledTableCell>{e.relation}</StyledTableCell>
                              </StyledTableRow>
                            )}
                          </TableBody>
                        </Table>
                      </div> :
                      <div style={{ height: 200 }}>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <span style={{ marginLeft: 15 }}>No Data</span> </div>
                    }
                  </div>
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={2} >
              <Grid container spacing={2} >
                <Grid item xs={12}>
                  <div className={'c-card2'} style={{ padding: 0 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 7 }}>Education Details</h5>

                    {employeeDetails.education && employeeDetails.education.length > 0 ?
                      <div style={{ marginBottom: 12, marginTop: 5 }}>
                        <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell width={235}>School/College</StyledTableCell>
                              <StyledTableCell width={165}>University</StyledTableCell>
                              <StyledTableCell width={100}>Education</StyledTableCell>
                              <StyledTableCell width={100}>Course</StyledTableCell>
                              <StyledTableCell width={100}>Duration</StyledTableCell>
                              <StyledTableCell width={50}>Passing</StyledTableCell>
                              <StyledTableCell width={90}>Percentage</StyledTableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {employeeDetails.education.map((e: any) =>
                              <StyledTableRow key={e.id}>
                                <StyledTableCell>{e.college}</StyledTableCell>
                                <StyledTableCell>{e.university}</StyledTableCell>
                                <StyledTableCell>{e.education}</StyledTableCell>
                                <StyledTableCell>{e.course}</StyledTableCell>
                                <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell>
                                <StyledTableCell>{moment(e.passing_year).format("YYYY")}</StyledTableCell>
                                <StyledTableCell>{e.percentage}</StyledTableCell>
                              </StyledTableRow>
                            )}
                          </TableBody>
                        </Table>
                      </div> :
                      <div style={{ height: 200 }}>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        <span style={{ marginLeft: 15 }}>No Data</span> </div>
                    }
                  </div>
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={3} >
              <Grid container spacing={2} >
                <Grid item xs={3.5}>
                  <div className={'c-card2'} style={{ padding: 12, paddingTop: 12 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Employement Details</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Gross Salary</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{(employeeDetails && employeeDetails.salary) ? `₹ ${employeeDetails.salary[0].grossSalary}` : '-'}</h5>

                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Cost To Company (CTC)</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{(employeeDetails && employeeDetails.salary) ? `₹ ${employeeDetails.salary[0].grossSalary}` : '-'}</h5>

                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Assessment Year</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{(employeeDetails && employeeDetails.salary) ? `${employeeDetails.salary[0].assessmentYear}` : '-'}</h5>

                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Start Date</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{(employeeDetails && employeeDetails.salary && employeeDetails.salary[0].startDate) ? `${moment(employeeDetails.salary[0].startDate).format("DD MMM YYYY")}` : '-'}</h5>

                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>End Date</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{(employeeDetails && employeeDetails.salary && employeeDetails.salary[0].endDate) ? `${moment(employeeDetails.salary[0].endDate).format("DD MMM YYYY")}` : '-'}</h5>

                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Date Of Joining</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{(employeeDetails && employeeDetails.dateOfJoining != null) ? `${moment(employeeDetails.dateOfJoining).format("DD MMM YYYY")}` : '-'}</h5>

                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Date Of Resign</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 20 }}>{(employeeDetails && employeeDetails.dateofResign) ? `${moment(employeeDetails.dateofResign).format("DD MMM YYYY")}` : '-'}</h5>

                    <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Reason Of Resign</h5>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>{(employeeDetails && employeeDetails.reasonOfResign) ? `${employeeDetails.reasonOfResign}` : '-'}</h5>
                  </div>
                </Grid>
                <Grid item xs={8.5}>
                  <div className={'c-card2'} style={{ padding: 15, paddingTop: 10, paddingBottom: 10 }}>
                    <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2 }} label={<>KYC Pending<CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#49a563', backgroundColor: '#edf6ef', fontSize: 12, marginTop: 2 }} label={<>KYC Done<CheckIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15 }}>Compliance Details</h5>
                    <Divider sx={{ mt: 0.5, mb: 1 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Nominee Name</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.nomineeName) ? employeeDetails.nomineeName : '-'}</h5>
                      </Grid>
                      <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Nominee Relation</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.nomineeRelation) ? employeeDetails.nomineeRelation : '-'}</h5>
                      </Grid>
                      <Grid item xs={4}>
                        <h5 style={{ fontWeight: 'normal', color: '#9da7b7', fontSize: 13 }}>Bank Linked Phone</h5>
                        <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14, marginBottom: 3 }}>{(employeeDetails && employeeDetails.bankLinkPhone) ? employeeDetails.bankLinkPhone : '-'}</h5>
                      </Grid>
                    </Grid>
                  </div>
                  <div className={'c-card2'} style={{ paddingTop: 10, paddingBottom: 10, marginTop: 15 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 7 }}>Employee Documents</h5>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        {(employeeDetails.attachments && employeeDetails.attachments.length > 0) ?
                          <div style={{ marginBottom: 12, marginTop: 5 }}>
                            <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                              <TableHead>
                                <TableRow>
                                  <StyledTableCell width={100}>Preview</StyledTableCell>
                                  <StyledTableCell width={230}>Document Name</StyledTableCell>
                                  {/* <StyledTableCell width={230}>File Name</StyledTableCell> */}
                                  <StyledTableCell width={230}>Type</StyledTableCell>
                                  <StyledTableCell width={225}>Size</StyledTableCell>
                                  <StyledTableCell width={225}></StyledTableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {employeeDetails.attachments.map((e: any) =>
                                  <StyledTableRow key={e._id}>
                                    <StyledTableCell>
                                      {
                                        e.s3Data?.mimetype === 'application/pdf' ? <PictureAsPdfIcon style={{ color: '#c33b3b', backgroundColor: '#fbecec', }}></PictureAsPdfIcon> :
                                          <img src={(e.s3Data) ? e.s3Data?.location || '' : ''} style={{ width: '40px', height: '40px', borderRadius: 5, border: '.5px solid #e9ecf1', objectFit: 'cover' }} />
                                      }
                                    </StyledTableCell>
                                    <StyledTableCell>
                                      {e.attachmentLabel === 'termsAndConditionPhoto' && 'Terms & Condition'}
                                      {e.attachmentLabel === 'bgvConsentPhoto' && 'BGV Consent'}
                                      {e.attachmentLabel === 'thumbPhoto' && 'Thumb'}
                                      {e.attachmentLabel === 'aadharCard' && 'Aadhar Card'}
                                      {e.attachmentLabel === 'panCard' && 'Pan Card'}
                                      {e.attachmentLabel === 'passbook' && 'Passbook'}
                                      {e.attachmentLabel === 'pvc' && 'Police Verification Certificate'}
                                      {e.attachmentLabel === 'bvc' && 'Background Verification Certificate'}
                                    </StyledTableCell>
                                    {/* <StyledTableCell>{e.s3Data?.originalname || ''}</StyledTableCell> */}
                                    <StyledTableCell>{e.s3Data?.mimetype || ''}</StyledTableCell>
                                    <StyledTableCell>{formatBytes(e.s3Data?.size || 0, 0)}</StyledTableCell>
                                    <StyledTableCell>
                                      <PreviewIcon
                                        onClick={() => {
                                          setDocumentModel(true)
                                          setDocument({ name: "Document Preview", document: e.s3Data?.location || '', mimetype: e.s3Data?.mimetype });
                                        }}
                                        style={{
                                          height: 30, width: 30, borderRadius: 5, padding: 5, color: '#488dff', backgroundColor: '#fff', fontSize: 20, marginLeft: 10, marginTop: 0
                                        }}
                                      />
                                      <DeleteIcon
                                        onClick={() => {
                                          handleEmpDeleteAttachment('aadhar', e._id);
                                        }}
                                        style={{
                                          height: 30, width: 30, borderRadius: 5, padding: 5, color: '#c33b3b',
                                          backgroundColor: '#fbecec', fontSize: 20, marginLeft: 10, marginTop: 0
                                        }}
                                      />
                                    </StyledTableCell>
                                  </StyledTableRow>
                                )}
                              </TableBody>
                            </Table>
                          </div> :
                          <div style={{ height: 200 }}>
                            <Divider sx={{ mt: 0.5, mb: 1 }} />
                            <Alert severity="error">
                              No Documents Uploaded. Please upload the employee documents by editing employee
                            </Alert>
                          </div>
                        }
                      </Grid>
                    </Grid>
                  </div>

                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={4} >
              <Grid container spacing={2} >
                <Grid item xs={12}>
                  <div className={'c-card2'} style={{ padding: 0 }}>
                    <h5 style={{ fontWeight: 'bold', color: '#000', fontSize: 15, marginLeft: 15, marginTop: 7 }}>Previous Employment Details</h5>

                    {employeeDetails.prevEmployment && employeeDetails.prevEmployment.length > 0 ?
                      <div style={{ marginBottom: 12, marginTop: 5 }}>
                        <Table stickyHeader sx={{ width: '100%' }} size='small' aria-label="customized table">
                          <TableHead>
                            <TableRow>
                              <StyledTableCell width={235}>Employer Name</StyledTableCell>
                              <StyledTableCell width={225}>Title</StyledTableCell>
                              <StyledTableCell width={150}>Salary</StyledTableCell>
                              <StyledTableCell width={150}>CTC</StyledTableCell>
                              <StyledTableCell width={100}>Duration</StyledTableCell>
                              {/* <StyledTableCell></StyledTableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {employeeDetails.prevEmployment.map((e: any) =>
                              <StyledTableRow key={e.id}>
                                <StyledTableCell>{e.name}</StyledTableCell>
                                <StyledTableCell>{e.title}</StyledTableCell>
                                <StyledTableCell>{e.gross_salary}</StyledTableCell>
                                <StyledTableCell>{e.ctc}</StyledTableCell>
                                <StyledTableCell>{moment(e.start_date).format("YYYY")} - {moment(e.end_date).format("YYYY")}</StyledTableCell>
                              </StyledTableRow>
                            )}
                          </TableBody>
                        </Table>
                      </div> :
                      <div style={{ height: 200 }}>
                        <Divider sx={{ mt: 0.5, mb: 1 }} />
                        No Data</div>
                    }
                  </div>
                </Grid>
              </Grid>
            </StyledTabPanel>
            <StyledTabPanel value={value} index={5} >
              <Grid container spacing={2} >
                <Grid item xs={12}>
                  <div className={'c-card2'} style={{ padding: 0 }}>
                    {docData && <DocAttachInfo docList={docData} onDelete={docDelete} onClose={closeDocAttach} collectionName={'Employee'} collectionRefId={employeeId} />}
                  </div>
                </Grid>
              </Grid>
            </StyledTabPanel>
          </Box>
        </Grid>

        <Grid item xs={3} style={{ height: '85vh', overflow: 'auto' }} mt={3} pr={1}>
          <Grid container p={0} spacing={2} mt={-4}>
            <Grid item xs={12}>
              <h4>View More Employee</h4>
              <Autocomplete
                disablePortal
                id={`Search Employee}`}
                forcePopupIcon={false}
                style={{ width: '100%', marginTop: 10 }}
                classes={{ paper: classes.paper }}
                // getOptionLabel={option => option.name}
                options={[]}

                renderInput={(params) => <TextField {...params}
                  // style={{width:300}} 
                  className='c-text-field-4'
                  variant="standard"
                  name="search"
                  size='small'
                  placeholder={`Search Employee...`}
                  InputProps={{ ...params.InputProps, disableUnderline: true }}
                />}
              />
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultEmpImg}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', padding: 1, ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#49a563', backgroundColor: '#edf6ef', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CheckIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultImg1}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultImg1}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultImg1}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultImg1}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultImg1}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultImg1}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className={'c-card2'} style={{ padding: 10, paddingLeft: 10 }}>
                <Grid container>
                  <Grid item xs={3.5}>
                    <Avatar
                      src={DefaultImg1}
                      sx={{ width: 60, height: 60, border: '.5px solid #e9ecf1', objectFit: 'cover', ml: 1, mt: 0.5, mb: 0.5 }}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <h5 style={{ fontWeight: 'normal', color: '#000', fontSize: 14 }}>Tanmay Buradkar</h5>
                    <p style={{ fontSize: 13 }}>tanmayburadkar7390@gmail.com<br />8208222895 | 28 yrs
                      <Chip size='small' style={{ height: 18, float: 'right', borderRadius: 7, color: '#c33b3b', backgroundColor: '#fbecec', fontSize: 12, marginTop: 2, marginRight: -10 }} label={<>KYC <CloseIcon style={{ fontSize: 12, float: 'right', marginTop: '3px', marginLeft: '3px', marginRight: '-2px' }} /></>} />
                    </p>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>


      </Grid>
      <Modal
        open={documentModel}
        onClose={(event: any, reason: any) => {
          if (reason !== 'backdropClick') {
            setDocumentModel(false)
          }
        }}
      >
        <Box sx={style}>
          <Grid container >
            <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p: 2, pl: 2, bgcolor: '#e9ecf1' }} style={{ borderTopLeftRadius: 8, borderTopRightRadius: 8, height: 50 }} >
              <div style={{ float: 'right', marginTop: -7, marginRight: -5 }}>
                <IconButton size='small' onClick={() => setDocumentModel(false)} style={{ marginRight: -5 }} >
                  <HighlightOffOutlinedIcon color="error" />
                </IconButton>
              </div>
              <h3 style={{ marginTop: -2 }}>{document?.name}</h3>
            </Grid>

          </Grid>
          {(document && document?.mimetype == 'application/pdf') ?
            <object style={{ height: "40vh", width: "50%", borderRadius: 20 }} contextMenu="true" data={document.document} type="application/pdf" >
            </object>
            :
            <img src={document?.document} style={{ marginTop: 5, width: '100%', height: 'auto', padding: 5, borderRadius: 15, border: '.5px solid #e9ecf1', objectFit: 'cover' }} />
          }
        </Box>
      </Modal>
    </>
  );
}
export default EmployeeViewPage;


function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}